import { apiClient } from "@/api/client";
import type { AcceptInviteData } from "@/api/restaurant/auth";
import { API_ENDPOINTS } from "@/config/app";
import type { LoginFormData } from "@/modules/LoginForm/types";
import { getAuthHeader } from "@/utils/getAuthHeader";

import type {
  IAdminLogin,
  IMeAdminResponse,
  NewPasswordPayload,
  ResetPayload,
} from "./types";

export const authApi = {
  async postLogin(userData: LoginFormData) {
    const response = await apiClient.postPublic<IAdminLogin>(
      `${API_ENDPOINTS.ADMIN}/auth/login`,
      userData
    );
    return response;
  },

  async postLogout(token: string) {
    return await apiClient.post(
      `${API_ENDPOINTS.ADMIN}/auth/logout`,
      undefined,
      getAuthHeader(token)
    );
  },

  async postAcceptTeamInvite(token: string, data: AcceptInviteData) {
    const response = await apiClient.postPublic(
      `${API_ENDPOINTS.ADMIN}/auth/accept-invite?token=${token}`,
      data
    );
    return response;
  },

  async checkInviteTeamToken(token: string): Promise<{ email: string }> {
    const response = await apiClient.getPublic<{ email: string }>(
      `${API_ENDPOINTS.ADMIN}/auth/validate-invite-token?token=${token}`
    );
    return response;
  },

  async getMe(): Promise<IMeAdminResponse> {
    const response = await apiClient.get<IMeAdminResponse>(
      `${API_ENDPOINTS.ADMIN}/auth/me`
    );
    return response;
  },

  async postForgotPassword(data: ResetPayload) {
    const response = await apiClient.postPublic<ResetPayload>(
      `${API_ENDPOINTS.ADMIN}/auth/forgot-password`,
      data
    );
    return response;
  },

  async checkResetPasswordAdminToken(
    token: string
  ): Promise<{ email: string }> {
    const response = await apiClient.getPublic<{ email: string }>(
      `${API_ENDPOINTS.ADMIN}/auth/validate-reset-password-token?token=${token}`
    );
    return response;
  },

  async sendNewPassword(token: string, data: NewPasswordPayload) {
    const response = await apiClient.postPublic(
      `${API_ENDPOINTS.ADMIN}/auth/set-password?token=${token}`,
      data
    );
    return response;
  },
};
